export const environment = {
  production: true,
  LocationsApiBaseUrl: '/api/locations',
  FeedDataAPIBaseURL: '/api/feed_data',
  OrchestratorApiBaseUrl: '/api/orchestrator',
  UnderstandAgentApiBaseUrl: '/api/understand',
  googleMapsApiKey: 'AIzaSyAJZdW9wANQy6RwHpbTFsXZPX78pd1O9cY',
  loggingApiUrl: '/api/logging',
  disableLogging: false,
  unleashFrontEndKey: 'ubiquity:development.2a2a85ad8ca75376765e9eb32f764a4f9f4e3bac7a1e020ab6c525f7',
  keycloak: {
    url: 'https://keycloak.filterlabs.ai',
    realm: 'filter-labs-web',
    clientId: 'web-app'
  }
};
